import ReactRogue from "./ReactRogue";

function App() {
  return (
    <div className="App">
      <ReactRogue width={40} height={40} tileSize={16} />
    </div>
  );
}

export default App;
